
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { useTranslation } from 'react-i18next';
import DashboardButton from "../Setting/dashboardButton";


export default function IndexShop() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Shop',
            url: null
        },
    ]
    return (
        <>
            <div className="text-left  bg-white  p-3 m-4 directions  h-[100vh] mb-5 ">

                <BreadCrump data={breadcrump}></BreadCrump>
                <DashboardButton item="shop setting" DashboardMenu={DashboardMenu}></DashboardButton>

              
                
            </div>

        </>
    )
}